module.exports = __webpack_public_path__ + "img/wide.01fc8112.jpg";